import { Middleware } from '@reduxjs/toolkit';

import Track, { OnePayEventNames } from 'modules/tracking';

const trackingMiddleware: Middleware = () => (next) => (action: any) => {
  const { type, error } = action;
  if (type.includes('/rejected')) {
    Track(OnePayEventNames.onePayAPIError, { api: type, ...error });
  }
  return next(action);
};

export default trackingMiddleware;
